import { createEvent } from 'effector';
import { getCHCitiesFx, getCHComplexesFx } from './effects.js';

export const changeCenterHomeFiltersEv = createEvent();

export const resetCenterHomeFiltersEv = createEvent();

export const applyFiltersEv = createEvent();

export const changeHexPropEv = createEvent();

export const initCHStoreEv = createEvent();

export const togglePriceTypeEv = createEvent();

export const changeMobilePopupEv = createEvent();

export const resetMobilePopupEv = createEvent();

export const applyQueryFiltersEv = createEvent();

export const getCHComplexesEv = createEvent();

export const getCHCitiesEv = createEvent();

export const getCHHexagonsEv = createEvent();

export const getCHDistrictsEv = createEvent();
